
Module.prototype.templatesCache = {};

Module.prototype.renderTemplate = function (templateName, data) {

	var template;
	if (!this.templatesCache[templateName]) {
		var source = $('#' + templateName + 'Template').html();
		template = Handlebars.compile(source);
		this.templatesCache[templateName] = template;
	}
	template = this.templatesCache[templateName];
	var html = template(data);

	return $(html);

};

Module.prototype.storeValue = function (name, val) {
	if (window.localStorage) {
		window.localStorage[name] = val;
	}
}

Module.prototype.getStoredValue = function (name) {
	if (window.localStorage) {
		return window.localStorage[name] || '';
	}

	return null;
}



Module.prototype.query = function (name, defaultVal) {

	var match = location.href.match(new RegExp('[?|&]' + name + '=(.*?)(&|#|$)'));

	if (match && match[1]) {
		return match[1];
	}

	return defaultVal || '';
}



Module.prototype.print = function ($el, $appendToBody) {
	var $contentBody = $el.clone();
	var CHUNK_SIZE = 2000;
	var content = '';


	$.fn.outerHTML = function (s) {
		return s
		? this.before(s).remove()
		: $("<p>").append(this.eq(0).clone()).html();
	};


	try {
		content = $contentBody.outerHTML();
	} catch (e) {
		alert('Unprintable content');
		return;
	}

	var debugMode = this.query('..printdebug..') == 'true';
	var htmlMode = debugMode || false; // TODO - check for non-Dev

	var html = [
		'<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">',
		'<html xmlns="http://www.w3.org/1999/xhtml">',
			'<head>',
				$('head').html(),  // Carry over all styles
			'</head>',

			'<body id="RSCat" class="printMode ' + (htmlMode ? 'printHTML' : '') + '">',
				'<div id="MODPage" class="MOD printMode">',
					content,
					($appendToBody ? $appendToBody.outerHTML() : ''),
				'</div>',
			'</body>',
		'</html>'
	];

	var htmlString = html.join('');
	htmlString = htmlString.replace(/(<:)/g, '<');  // IE was returning <:section> format on HTML5 tags. Quick fix. 
	htmlString = htmlString.replace(/(<\/:)/g, '</');  // Tag wasn't closing correctly, so i split this into a different regex

	// C# Doesn't have a unescape so we'll base64 encode it.
	// html = $.toBase64(html.join(''));  // jQuery version uses built in Firefox method which was failing

	htmlString = unescape(encodeURIComponent(htmlString));

	html = "B64ENC" + this.base64Encode(htmlString);

	var url = "~/Print/PrintPDFfromHTML/".resolveUrl();

	if (MOD.sKey) {
		url += (/\?/.test(url) ? '&' : '?') + MOD.sKey;
	}

	if (debugMode) {
		url += '?..printdebug..=true';
	}

	var form = $("body").append("<form id='print-form' method='post' action='" + url + "' target='_blank'></form>");

	//split up the html into byte size chunks
	var text, x;
	var numChunks = Math.ceil(html.length / CHUNK_SIZE);

	for (x = 0; x < numChunks; x++) {
		text = html.substr(x * CHUNK_SIZE, CHUNK_SIZE);
		$("#print-form").append("<input type='hidden' name='html" + x + "' value='" + (text) + "' />");
	}

	$("#print-form").append("<input type='hidden' name='numHtmlChunks' value='" + numChunks + "' />");

	$("#print-form").submit();
	$("#print-form").remove();
};

Module.prototype.base64Encode = function (sIn) {
	var sBase64Forward = {
		'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8, 'J': 9,
		'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16, 'R': 17, 'S': 18, 'T': 19,
		'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24, 'Z': 25, 'a': 26, 'b': 27, 'c': 28, 'd': 29,
		'e': 30, 'f': 31, 'g': 32, 'h': 33, 'i': 34, 'j': 35, 'k': 36, 'l': 37, 'm': 38, 'n': 39,
		'o': 40, 'p': 41, 'q': 42, 'r': 43, 's': 44, 't': 45, 'u': 46, 'v': 47, 'w': 48, 'x': 49,
		'y': 50, 'z': 51, '0': 52, '1': 53, '2': 54, '3': 55, '4': 56, '5': 57, '6': 58, '7': 59,
		'8': 60, '9': 61, '+': 62, '/': 63
	};
	var sBase64Reverse = [
		'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
		'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j',
		'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1',
		'2', '3', '4', '5', '6', '7', '8', '9', '+', '/'
	];

	var count = sIn.length;
	var i, index = -1, iBits, sOut = new Array(Math.ceil(count * 4 / 3)); //pre-allocate the array
	var chars = sBase64Reverse;

	for (i = 0; i < count; i += 3) {
		iBits = (sIn.charCodeAt(i) << 16)
			+ ((sIn.charCodeAt(i + 1) & 0xff) << 8)
			+ (sIn.charCodeAt(i + 2) & 0xff);

		sOut[++index] = chars[iBits >> 18 & 0x3f];
		sOut[++index] = chars[iBits >> 12 & 0x3f];

		//tried to unroll this, but couldn't get results to match
		sOut[++index] = (i > count - 2) ? "=" : chars[iBits >> 6 & 0x3f];
		sOut[++index] = (i > count - 3) ? "=" : chars[iBits & 0x3f];
	}

	return sOut.join("");
};
